// extracted by mini-css-extract-plugin
export default {"overlay":"Dx-z","bodyOpen":"Ex-z","content":"Fx-z","header":"Gx-z","close":"Hx-z","closeNoHeading":"Ix-z"};